// extracted by mini-css-extract-plugin
module.exports = {"formitemRow":"salesUserInfo_formitemRow__1mRdR","required":"salesUserInfo_required__3oVum"};